var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagSw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_958_13123",
    transform: "translate(-0.3) scale(0.00125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_958_13123",
    width: 1280,
    height: 800,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABQAAAAMgAgMAAAAB9idoAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEUAaqf+zAD///9Dh+PyAAAAAWJLR0QCZgt8ZAAAAAd0SU1FB+gDAhctGh9Ll3QAAARASURBVHja7dFBDQAgDATBM4l/Kygg4VVaMqvgOk0KWpdFAAECBCiAAAECFECAAAEKIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAhQAAECBCiAAAECFECAAAEKIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAggQIEABBAgQoAACBAhQAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAggQIEABBAgQoAACBAhQAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECFECAAAEKIECAAAUQIECAAggQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECFECAAAEKIECAAAUQIECAAggQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQoAACBAhQAAECBCiAAAECFECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQoAACBAhQAAECBCiAAAECFECAAAGOP06HpyMACBAgQAEECBCgAAIECFAAAQIEKIAAAQIUQIAAAQogQIAABRAgQIACCBAgQAEECBCgAAIECBCgAAIECFAAAQIEKIAAAQIUQIAAAQogQIAABRAgQIACCBAgQAEECBCgAAIECFAAAQIECBABQIAAAQogQIAABRAgQIACCBAgQAEECBCgAAIECFAAAQIEKIAAAQIUQIAAAQogQIAABRAgQIAABRAgQIACCBAgQAEECBCgAAIECFAAAQIEKIAAAQIUQIAAvwSsqNWYiQEECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFAAAQIEKIAAAQIUQIAAAQogQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECFAAAQIEKIAAAQIUQIAAAQogQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIACCBAgQAEECBCgAAIECFAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIACCBAgQAEECBCgAAIECFAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIUQIAAAQogQIAABRAgQIACCBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIUQIAAAQogQIAABRAgQIACCBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBCgAAIECFAAAQIEKIAAAQIUQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDg+zYhqKHOhnW7owAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyNC0wMy0wMlQyMzo0NToyNiswMDowMF9qdNoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjQtMDMtMDJUMjM6NDU6MjYrMDA6MDAuN8xmAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSw);
export default __webpack_public_path__ + "static/media/flag-sw.1fc7e0a63ee37951b56f1fea1fbb08a8.svg";
export { ForwardRef as ReactComponent };